export const ROUTES = {
  System: {
    AdminLogin: '/loginAsAdmin',
  },

  Auth: {
    CheckInvitation: '/invite',
    ChangePassword: '/resetpassword',
    CreateAccount: '/create-account',
    ForgotPassword: '/forgot-password',
    LogIn: '/login',
    Logout: '/logout',
    SelectCompany: '/select-company',
    Welcome: '/',
  },

  Public: {
    TermsAndConditions: '/terms-of-use',
    TermsOfPurchase: '/terms-of-purchase',
    PrivacyPolicy: '/privacy-policy',
    WebToLeadForm: '/proposal-request',
    HealthCheck: '/health-check',
    notFound: '/not-found',
    TEMPORARY_SFDC_DEV: '/temporary/sfdc-dev',
    TEMPORARY_SFDC_QA: '/temporary/sfdc-qa',
    TEMPORARY_SFDC_STG: '/temporary/sfdc-stg',
  },

  Private: {
    // Dashboard
    Dashboard: {
      // Activities
      ActivityList: '/dashboard',
      ActivityDetails: '/dashboard/:detailsTarget',
      // Leads
      Lead: {
        Create: '/dashboard/new-proposal',
      },
    },
    newSiteSurveyTaskCard: {
      segment: 'site-survey',
      welcome: '/dashboard/:detailsTarget/site-survey',
      submitSurvey: '/dashboard/:detailsTarget/submit-site-survey',
    },
    siteSurvey: {
      segment: 'site-survey',
      welcome: '/:detailsTarget/site-survey',
      exterior: '/:detailsTarget/site-survey/exterior/:stepNumber/:subStep?',
      system: '/:detailsTarget/site-survey/system/:stepNumber/:subStep?',
      attic: '/:detailsTarget/site-survey/attic/:stepNumber/:subStep?',
      decking: '/:detailsTarget/site-survey/decking/:stepNumber/:subStep?',
      anythingElse: '/:detailsTarget/site-survey/anything-else',
      submitSurvey: '/:detailsTarget/submit-site-survey',
    },
    // Products
    ProductsList: '/products',
    // Profile
    Profile: {
      View: '/profile',
      Edit: '/profile/edit',
    },
    // Sales Resources
    SalesResources: '/sales-resources',
    ManageUsers: '/manage-users',
    AccountSettings: '/account-settings',
    EstimatedSolarBom: '/:proposalId/estimated-bom',
    SalesTrainingLink: '/training/instantAuth',
    ProposalPricing: {
      segment: 'proposal-pricing',
      page: '/dashboard/:detailsTarget/proposal-pricing',
    },
  },
};

export const modalRoutes = {
  redesign: '/interactive-redesign',
};
